// src/components/FeaturesSectionCompact.jsx
import React from 'react';
import { CheckCircle } from 'lucide-react';

const features = [
  {
    image: '/imagens/empreendedora-urbana.jpeg',
    title: 'Seja o Protagonista do Seu Negócio',
    description:
      'Cadastre, capte e comercialize seus imóveis com autonomia total na plataforma. Você no controle de cada etapa do processo.',
    reverse: false,
  },
  {
    image: '/imagens/AdobeStock_479932092.jpeg',
    title: 'Escolha sua Rede de Relacionamentos',
    description:
      'Decida com quem quer fazer negócios. Selecione parceiros e sócios estratégicos para criar alianças de confiança e potencializar seus resultados.',
    reverse: true,
  },
  {
    image: '/imagens/AdobeStock_611093177.jpeg',
    title: 'Portfólio Ilimitado em Todo o País',
    description:
      'Amplie suas oportunidades sem fronteiras. Acesse imóveis em qualquer região do Brasil e multiplique suas possibilidades de parceria.',
    reverse: false,
  },
];

const FeaturesSectionCompact = () => {
  return (
    <section className="bg-elion-navy py-24">
      {' '}
      {/* Espaçamento superior e inferior aumentados */}
      <div className="max-w-5xl mx-auto px-4 space-y-6">
        {features.map((feature, idx) => (
          <div
            key={idx}
            className={`flex flex-col md:flex-row ${
              feature.reverse ? 'md:flex-row-reverse' : ''
            } bg-[#0e1a2b] border border-yellow-500/30 rounded-md shadow-md hover:shadow-lg transition duration-300 overflow-hidden`}
          >
            {/* Imagem */}
            <div className="flex-shrink-0">
              <img
                src={feature.image}
                alt={feature.title}
                className="w-full md:w-72 h-44 object-cover md:rounded-none"
              />
            </div>

            {/* Texto */}
            <div className="p-5 flex flex-col justify-center">
              <h3 className="text-lg md:text-xl font-bold text-white flex items-center gap-2 mb-2">
                <CheckCircle className="w-5 h-5 text-green-400" />
                {feature.title}
              </h3>
              <p className="text-sm md:text-base text-gray-300 leading-normal">
                {feature.description}
              </p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default FeaturesSectionCompact;
